import { TextArea } from 'modules/TextArea';
import { MenuInput } from './MenuInput';
import { InputContainer } from './styled';
export function MenuTextArea(props) {
    return (<MenuInput render={<InputContainer>
          <TextArea {...props} stretch/>
        </InputContainer>}/>);
}
